define('taoQtiItem/qtiCreator/widgets/states/Inactive',['taoQtiItem/qtiCreator/widgets/states/factory'], function(stateFactory){

    return stateFactory.create('inactive', function(){

    }, function(){
        
    });
});

